/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListDetails200Response,
  ListNotices200Response,
  ListOperations400Response,
  ListStatements200Response,
} from '../models/index';
import {
    ListDetails200ResponseFromJSON,
    ListDetails200ResponseToJSON,
    ListNotices200ResponseFromJSON,
    ListNotices200ResponseToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    ListStatements200ResponseFromJSON,
    ListStatements200ResponseToJSON,
} from '../models/index';

export interface DownloadDetailsZipRequest {
    ids: Array<string>;
}

export interface DownloadNoticesZipRequest {
    ids: Array<string>;
}

export interface DownloadStatementsZipRequest {
    ids: Array<string>;
}

export interface ListDetailsRequest {
    page?: number;
    count?: number;
}

export interface ListNoticesRequest {
    page?: number;
    count?: number;
}

export interface ListStatementsRequest {
    page?: number;
    count?: number;
}

/**
 * 
 */
export class OperatorsApi extends runtime.BaseAPI {

    /**
     * 明細データ一括ダウンロード
     */
    async downloadDetailsZipRaw(requestParameters: DownloadDetailsZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling downloadDetailsZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/details/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 明細データ一括ダウンロード
     */
    async downloadDetailsZip(requestParameters: DownloadDetailsZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadDetailsZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払通知書一括ダウンロード
     */
    async downloadNoticesZipRaw(requestParameters: DownloadNoticesZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling downloadNoticesZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/notices/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 支払通知書一括ダウンロード
     */
    async downloadNoticesZip(requestParameters: DownloadNoticesZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadNoticesZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 会社精算書一括ダウンロード
     */
    async downloadStatementsZipRaw(requestParameters: DownloadStatementsZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling downloadStatementsZip().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/statements/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 会社精算書一括ダウンロード
     */
    async downloadStatementsZip(requestParameters: DownloadStatementsZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadStatementsZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 明細データ一覧
     */
    async listDetailsRaw(requestParameters: ListDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDetails200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/details`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * 明細データ一覧
     */
    async listDetails(requestParameters: ListDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDetails200Response> {
        const response = await this.listDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払通知書一覧
     */
    async listNoticesRaw(requestParameters: ListNoticesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNotices200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/notices`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListNotices200ResponseFromJSON(jsonValue));
    }

    /**
     * 支払通知書一覧
     */
    async listNotices(requestParameters: ListNoticesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNotices200Response> {
        const response = await this.listNoticesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 会社精算書一覧
     */
    async listStatementsRaw(requestParameters: ListStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListStatements200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/operator/statements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListStatements200ResponseFromJSON(jsonValue));
    }

    /**
     * 会社精算書一覧
     */
    async listStatements(requestParameters: ListStatementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListStatements200Response> {
        const response = await this.listStatementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
